export default __webpack_public_path__ + "static/media/socialMedia.15682bd3.svg";